import React, {useState} from "react";
import Dropdown from 'react-bootstrap/Dropdown';

/**
 * Name prompt. Used three ways: the first-run gate (no profiles yet, not
 * dismissible), "nuevo perfil", and "renombrar".
 */
export function ProfileDialog({
    title,
    hint,
    initialValue = "",
    confirmLabel = "Guardar",
    profiles = [],
    onConfirm,
    onSelect,
    onCancel,
}) {
    const [name, setName] = useState(initialValue);
    const trimmed = name.trim();
    const taken = profiles.some(
        (profile) => profile.name.toLowerCase() === trimmed.toLowerCase() && profile.name !== initialValue
    );
    const canSave = trimmed !== "" && !taken;

    const submit = (event) => {
        event.preventDefault();
        if (canSave) onConfirm(trimmed);
    };

    return (
        <div className="gate">
            <form className="gate-card" onSubmit={submit}>
                <div className="brand gate-brand">
                    <span className="brand-dot" aria-hidden="true"/>
                    <span>Enchin<span className="brand-accent">Fit</span></span>
                </div>

                <h1 className="gate-title">{title}</h1>
                {hint && <p className="gate-hint">{hint}</p>}

                <input
                    className="gate-input"
                    type="text"
                    value={name}
                    autoFocus
                    maxLength={40}
                    placeholder="Tu nombre"
                    aria-label="Nombre del perfil"
                    onChange={(event) => setName(event.target.value)}/>

                {taken && <p className="gate-error">Ya existe un perfil con ese nombre.</p>}

                <div className="gate-actions">
                    {onCancel && (
                        <button type="button" className="btn-ghost" onClick={onCancel}>Cancelar</button>
                    )}
                    <button type="submit" className="btn-accent" disabled={!canSave}>{confirmLabel}</button>
                </div>

                {onSelect && profiles.length > 0 && (
                    <div className="gate-existing">
                        <p className="gate-existing-label">o seguí con un perfil que ya existe</p>
                        <div className="gate-profiles">
                            {profiles.map((profile) => (
                                <button
                                    type="button"
                                    key={profile.id}
                                    className="gate-profile"
                                    onClick={() => onSelect(profile.id)}>
                                    <span className="gate-avatar" aria-hidden="true">
                                        {profile.name.slice(0, 1).toUpperCase()}
                                    </span>
                                    {profile.name}
                                </button>
                            ))}
                        </div>
                    </div>
                )}
            </form>
        </div>
    );
}

/** Active profile in the top bar, with switching and management. */
export function ProfileMenu({profiles, active, onSelect, onCreate, onRename, onDelete, onReset}) {
    return (
        <Dropdown className="profile" align="end">
            <Dropdown.Toggle as="button" type="button" className="profile-toggle">
                <span className="gate-avatar" aria-hidden="true">
                    {active.name.slice(0, 1).toUpperCase()}
                </span>
                <span className="profile-name">{active.name}</span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="profile-menu">
                <Dropdown.Header>Perfiles</Dropdown.Header>
                {profiles.map((profile) => (
                    <Dropdown.Item
                        as="button"
                        type="button"
                        key={profile.id}
                        active={profile.id === active.id}
                        onClick={() => onSelect(profile.id)}>
                        {profile.name}
                    </Dropdown.Item>
                ))}
                <Dropdown.Divider/>
                <Dropdown.Item as="button" type="button" onClick={onCreate}>Nuevo perfil…</Dropdown.Item>
                <Dropdown.Item as="button" type="button" onClick={onRename}>Renombrar…</Dropdown.Item>
                <Dropdown.Item as="button" type="button" className="is-danger" onClick={onReset}>
                    Reiniciar progreso
                </Dropdown.Item>
                {profiles.length > 1 && (
                    <Dropdown.Item as="button" type="button" className="is-danger" onClick={onDelete}>
                        Borrar perfil
                    </Dropdown.Item>
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
}
